import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import Color from "color";
import React from "react";
export function getInternalLabel({
  ellipsizedName,
  id,
  annotationType,
  revTransform,
  angleAdjust,
  isPart,
  colorToUse,
  textPath,
  locationNumber
}) {
  if (!ellipsizedName) return null;
  const pathId = `${annotationType}${id}${locationNumber ?? ""}`;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("path", { id: pathId, fill: "none", d: textPath.print() }),
    /* @__PURE__ */ jsx(
      "text",
      {
        className: "veLabelText veCircularViewInternalLabelText ve-monospace-font",
        transform: (revTransform || "") + (angleAdjust ? ` rotate(${angleAdjust})` : ""),
        fill: isPart ? "#ac68cc" : annotationType === "primer" ? "black" : Color(colorToUse).isDark() ? "white" : "black",
        dy: annotationType === "primer" ? -7 : -3,
        children: /* @__PURE__ */ jsx(
          "textPath",
          {
            textAnchor: "middle",
            startOffset: "50%",
            xlinkHref: `#${pathId}`,
            children: ellipsizedName
          }
        )
      }
    )
  ] });
}
